import { faSave, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { cloneDeep } from 'lodash'
import { useEffect, useRef, useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import { ButtonSpinner } from '../../../../../../../components/ButtonSpinner/ButtonSpinner'
import { InputText } from '../../../../../../../components/Inputs'
import { InputFile } from '../../../../../../../components/Inputs/InputFile'
import { InputRadios } from '../../../../../../../components/Inputs/InputRadios'
import { ListFiles } from '../../../../../../../components/ListFiles/ListFiles'
import { ModalStatusServer } from '../../../../../../../components/Modals/ModalStatusServer'
import { isStatusSucess } from '../../../../../../../helpers/helpers'
import { useForm } from '../../../../../../../hooks/useForm'
import { useValidator } from '../../../../../../../hooks/useValidator'
import { useLang } from '../../../../../../../language'
import { BancosServices } from '../../../../../../facturacion/pages/Parametros/services/bancos.service'
import { CuentasBancariasServices } from '../../../../../../facturacion/pages/Parametros/services/cuentasbancarias.service'
import { DocumentosAdapters } from '../controllers/adapters/documentos.adapter'
import { DocumentosServices } from '../controllers/services/documentos.service'

export const ModalDocumento = ({ showModal_Documento, handleCloseModal_Documento,
    fetchPersonaDatosEconomicosGET, urlParams, fetchDocumentosGET }: any) => {

    // -------- variables 

    const Lang = useLang()

    const inputFileFichero: any = useRef(null)


    const [valuesValidationCuenta, handleValidationCuenta, handleResetValidationCuenta] = useValidator({
        nombre: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
    })

    // -------- Formulario principal

    const [formDocumento, handleInputDocumento, handleFormDocumento, resetFormDocumento] = useForm({
        ...DocumentosAdapters.GET.receive.schema({}),
    })

    // -------------------- POST Persona Entidad

    const [fetchPersonaEntidadPOST, fetchPersonaEntidadPOSTData] = DocumentosServices.POST()

    const handleSubmitCrear = () => {

        if (handleValidationCuenta(formDocumento)) {

            fetchPersonaEntidadPOST({
                body: {
                    ...formDocumento,
                    idproducto: showModal_Documento.payload?.idaparato,
                    archivo: inputFileFichero.current?.files[0],
                }
            })
        }

    }

    useEffect(() => {
        if (isStatusSucess(fetchPersonaEntidadPOSTData.status)) {
            fetchDocumentosGET()
            handleCloseModal_Documento()
        }
    }, [fetchPersonaEntidadPOSTData])


    // -------------------- PATCH Persona Entidad

    const [fetchPersonaEntidadPATCH, fetchPersonaEntidadPATCHData] = DocumentosServices.PATCH(showModal_Documento.payload?.id)

    const handleSubmitEditar = () => {

        if (handleValidationCuenta(formDocumento)) {
            fetchPersonaEntidadPATCH({
                body: {
                    ...formDocumento,
                    idevento: showModal_Documento.payload?.idevento,
                    // file: inputFileFichero.current?.files[0],
                }
            })
        }

    }

    useEffect(() => {
        if (isStatusSucess(fetchPersonaEntidadPATCHData.status)) {
            fetchDocumentosGET()
            handleCloseModal_Documento()
        }
    }, [fetchPersonaEntidadPATCHData])

    // ---------- DELETE Persona Entidad

    const [fetchPersonaEntidadDELETE, fetchPersonaEntidadDELETEData] = DocumentosServices.DELETE(showModal_Documento.payload?.id)

    useEffect(() => {

        if (isStatusSucess(fetchPersonaEntidadDELETEData.status)) {
            fetchDocumentosGET()
            handleCloseModal_Documento()
        }
    }, [fetchPersonaEntidadDELETEData])

    const handleSubmitDELETE = () => {

        fetchPersonaEntidadDELETE()
    }

    // Funciones helpers

    const handleChangeCheck = (e: any, name: string) => {

        let listaModulosTemp = cloneDeep(formDocumento[name])

        if (e.target.checked) {

            listaModulosTemp.push(e.target.name)

        } else {

            listaModulosTemp = listaModulosTemp.filter((item: any) => item !== e.target.name)
        }

        handleFormDocumento({
            ...formDocumento,
            [name]: listaModulosTemp
        })
    }

    // ------------- Modal Filtro Entidades

    const [showModal_FiltroEntidades, setShowModal_FiltroEntidades] = useState({
        value: false,
        payload: {}
    });

    const handleCloseModal_FiltroEntidades = () => setShowModal_FiltroEntidades({
        value: false,
        payload: {}
    });

    const handleShowModal_FiltroEntidades = (payload: any) => setShowModal_FiltroEntidades({
        value: true,
        payload
    });

    const [filterEntidad, setFilterEntidad] = useState<any>({
        id: '',
        nombre: '',
        sedes: []
    })

    useEffect(() => {

        handleFormDocumento({
            ...formDocumento,
            identidad: filterEntidad.id,
            entidad: filterEntidad.nombre,
            identidadsede: filterEntidad.sedes?.length === 1 ? filterEntidad.sedes[0]?.identidadsede : ''
        })

    }, [filterEntidad])

    // Actualizar variable de servicioTarget
    // const [sedes, setSedes] = useState<any>([])

    useEffect(() => {
        if (!formDocumento.identidad) {
            setFilterEntidad({
                id: '',
                nombre: '',
                sedes: []
            })
        }

        // const res = fetchServiciosGETData?.data?.items?.find((item: any) => item.id === formLinea.identidad)
        // setsedes({
        //     ...res
        // })

    }, [formDocumento.identidad])

    // Acciones al Mostrar / Ocultar la Modal

    useEffect(() => {

        if (showModal_Documento.value) {

            if (showModal_Documento.payload?.form) {

                handleFormDocumento({
                    ...showModal_Documento.payload?.form,
                })
            }

        } else {

            resetFormDocumento()
            handleResetValidationCuenta()
        }

    }, [showModal_Documento.value])

    const [fetchBancosGET, fetchBancosGETData] = BancosServices.GET()

    useEffect(() => {
        if (formDocumento.codbanco?.length === 4) {

            fetchBancosGET({
                params: {
                    codbanco: formDocumento.codbanco
                }
            })

        } else {
            handleFormDocumento({
                ...formDocumento,
                idbanco: ''
            })
        }
    }, [formDocumento.codbanco])

    useEffect(() => {

        handleFormDocumento({
            ...formDocumento,
            idbanco: fetchBancosGETData.data?.items?.[0]?.id || ''
        })

    }, [fetchBancosGETData])


    const handleDeleteAdjunto = () => {
        handleFormDocumento({
            ...formDocumento,
            adjunto: []
        })
    }

    return (
        <>

            <Modal show={showModal_Documento.value} onHide={handleCloseModal_Documento} size='lg' id='ModalRegistro'>
                <Modal.Header className='border-bottom-0 py-4'>
                    <Modal.Title className='h5'>
                        {showModal_Documento.payload?.action === 'EDIT' ? Lang('EDITAR_DOCUMENTO') : Lang('NUEVO_DOCUMENTO')}
                    </Modal.Title>
                    <button type="button" className="btn-close mx-0" aria-label="Close" onClick={handleCloseModal_Documento}></button>
                </Modal.Header>

                <Modal.Body className='px-4 py-0'>
                    <Form className='row'>

                        <Form.Group className="mb-3 col-12">
                            <InputText
                                label={Lang('NOMBRE_DOCUMENTO')}
                                name='nombre'
                                value={formDocumento.nombre}
                                onChange={handleInputDocumento}
                                validation={valuesValidationCuenta}
                                fetchData={showModal_Documento.payload.action === 'EDIT' ? fetchPersonaEntidadPATCHData : fetchPersonaEntidadPOSTData}
                                readonly={showModal_Documento.payload.action === 'EDIT'}
                            />
                        </Form.Group>

                        {
                            formDocumento.url_adjunto ?
                                <Form.Group className="mb-3 col-12">
                                    <Form.Label className='fw-500'>{Lang('FICHERO_ADJUNTO')}:</Form.Label>
                                    <ListFiles
                                        list={[{
                                            titulo: Lang('FICHERO_ADJUNTO'),
                                            url: formDocumento.url_adjunto,
                                        }]}
                                        withToken
                                        // onClickDelete={() => handleDeleteAdjunto()}
                                    />
                                </Form.Group>
                                :
                                <Form.Group className="mb-3 col-12">
                                    <Form.Label className='fw-500'>{Lang('DOCUMENTO')}:</Form.Label>
                                    <InputFile
                                        name='file'
                                        onChange={handleInputDocumento}
                                        referencia={inputFileFichero}
                                    />
                                </Form.Group>
                        }

                    </Form>
                </Modal.Body>
                <Modal.Footer className='border-0 d-flex justify-content-between'>
                    {
                        showModal_Documento.payload?.action === 'CREATE' ?
                            <>
                                <div></div>
                                <ButtonSpinner
                                    variant="secondary" type="submit" className="me-2"
                                    handleSubmit={handleSubmitCrear} fetchDataLoading={[fetchPersonaEntidadPOSTData.loading]}
                                    value={Lang('GUARDAR')} icon={<FontAwesomeIcon icon={faSave} />}
                                />
                            </>
                            :
                            <>
                                <ButtonSpinner
                                    variant="danger" type="submit" className="ms-2"
                                    handleSubmit={handleSubmitDELETE} fetchDataLoading={[fetchPersonaEntidadDELETEData.loading]}
                                    value={Lang('ELIMINAR')} icon={<FontAwesomeIcon icon={faTrash} className='me-1' />}
                                />
                                <div></div>
                            </>
                    }

                </Modal.Footer>
            </Modal>


            <ModalStatusServer fetchData={fetchPersonaEntidadPOSTData} />

            <ModalStatusServer fetchData={fetchPersonaEntidadDELETEData} />

            <ModalStatusServer fetchData={fetchPersonaEntidadPATCHData} />

        </>
    )
}
